import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '10', label: 'Criada' },
			{ value: '14', label: 'Faturando' },
			{ value: '16', label: 'Faturada' },
			{ value: '20', label: 'Recebendo' },
			{ value: '30', label: 'Recebida' },
			{ value: '40', label: 'Conferindo' },
			{ value: '50', label: 'Conferida' },
			{ value: '60', label: 'Endereçando' },
			{ value: '70', label: 'Concluída' },
			{ value: '80', label: 'Cancelada' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

